<template>
  <div class="view-body view-body--edit-order" @click="close($event);">
      <div class="view-data">
        <div class="order-alert" v-if="!userAlert && userAlertAccepted">
          Jesteś w trybie podglądu. Nie możesz edytować zlecenia.
        </div>
        <div class="view-data__header header-edit-order">
          <div class="order-name">
            <h1>{{pageTitle}} | {{order.number}} - {{order.name}}
              <div class="order-tooltip" @click="showOrderInfo = true">
                  informacje o zleceniu
              </div>
            </h1>
            <!--<p v-if="!historyMode">Status zlecenia:</p>-->
              <div v-if="!historyMode" @click="statuses = !statuses" class="badge badge--header" :class="{
                    'badge-red' : statusCode() == 'mm_build' || statusCode() == 'first_correct_mm' || statusCode() == 'second_correct_mm' || statusCode() == 'additional_correct_mm',
                    'badge-yellow' : statusCode() == 'to_accept',
                    'badge-navy' : statusCode() == 'first_gun_build' || statusCode() == 'second_gun_build' || statusCode() == 'first_correct_gun' || statusCode() == 'additional_correct_gun',
                    'badge-green' : statusCode() == 'accept',
                    'badge-light-grey' : statusCode() == 'archived',
                    'badge-dark-grey' : statusCode() == 'cancelled',
                    'badge-light-grey disabled' : isPageStatus(),
                    }">{{statusCode('name')}}
                  <div class="statuses" :class="{'show' : statuses}">
                    <ul>
                        <li v-for="status in statusList" :class="{'disabled-status' : checkStatus(status ? status.code : '')}" :key="status.id" @click="updateStatus(status.id, status); statuses = false">
                          {{status.name}}
                        </li>
                    </ul>
                  </div>
                  <div class="order-tooltip">
                    zmień status
                  </div>
              </div>
            </div>
            <div class="order-settings">
              <div class="editor">
                <p v-if="pageBlockedBy"><span>Edytuje:</span> {{pageBlockedBy}}</p>
              </div>
              <div class="history">
                <div class="history-cancel">
                  <img v-if="historyId != ''" src="../../assets/symbols/cancel.svg" @click="turnOffHistory()"/>
                </div>
                <div class="history-cell" style="width:45%">
                  <p>Pokaż historię</p>
                </div>
                <div class="history-cell" style="width:50%">
                  <vueselect :value="currentHistoryStatus" class="select--list select--list-small select--list-status select--list--footer white history-select" placeholder="wybierz status" :options="orderedHistory" :clearable="false" :searchable="false" label="name" @input="setHistory">
                    <template slot="option" slot-scope="option">
                      <div>{{option.name}}</div>
                    </template>
                    <template slot="no-options">
                      <p>Brak rekordów</p>
                    </template>
                  </vueselect>
                </div>
              </div>
            </div>
        </div>
        <div class="edit-body" :class="{'hideSearch' : hideSearch}">
          <div class="edit-body__column">
            <orderPages ref="orderPages" 
            :trashRoom="order.basketRoom" 
            :waitingRoom="order.waitingRoom" 
            :item="order.orderPages" 
            :id="order.id" 
            :switchActive="pageId" 
            :blockAddPage="blockAddPage"
            :tableType="tableType"
            @mouseup="activePageControl($event)" 
            @click="pageId = 0, tableType = $event" 
            @addComment="showCommentPopup = true"
            @blockAddPage="blockAddPage = true"
            @multiPage="handleMultiPage($event)"
            :historyMode="historyMode"
            :blocked="orderBlocked"
            :draggedProduct="draggedProduct"
            />
          </div>
          <div class="edit-body__column edit-body__column--midle">
            <productsInOrder
            v-if="tableType !== 'legals'"
            ref="productsInOrder" 
            :orderId="order.id" 
            :type="tableType" 
            :pageId="pageId" 
            :addSingle="addSingle"
            @pageBlocked="pageBlockedBy = $event"
            :historyMode="historyMode"
            :orderToCompare="orderToCompare"
            :blocked="orderBlocked"
            :historyList="histories"
            :historyId="historyId"
            :originalOrderId="originalOrderId"
            :selectedPages="selectedPages"
            :pagesList="order.orderPages"
            @draggedProduct="draggedProduct = $event"
            :orderMain="order"/>

            <legals v-if="tableType == 'legals'" :orderId="order.id"/>

            <switchPage 
            :pageId="pageId" 
            :pages="order.orderPages" 
            :tableType="tableType"
             @click="pageId = $event" 
             @input="pageId = $event"/>
          </div>
          <div class="edit-body__column edit-body__column--midle" @click="hideSearch = !hideSearch">
            <div class="hide-icon" :class="{'hideSearch' : hideSearch}">
              <img class="list-icon" src="../../assets/symbols/arrow-point-to-right.svg"/>
            </div>
          </div>
          <div class="edit-body__column" :class="{'hideSearch' : hideSearch}">
            <!-- <orderSearch @upload="upload = true" @addSingle="addSingle = $event"/> -->
            <globalSearch @upload="upload = true" @addSingle="addSingle = $event" :view="'orders'"></globalSearch>
            <editOrderUpload :orderId="order.id" :type="tableType" :pageId="pageId" :loadedFiles="filesList"/>
            <div class="button-group button-group--module">
              <button class="button-normal button-normal--cancel" @click="$router.push('/dashboard')">Wróć</button>
            </div>
          </div>
          <div class="edit-body__column">
          </div>
          <div class="edit-body__column">
            <headlines 
            :orderId="order.id" 
            :pageId="pageId" 
            :pages="order.orderPages" 
            :historyMode="historyMode"
            :blocked="orderBlocked"/>
          </div>
          <div class="edit-body__column">
          </div>
          <div class="edit-body__column">
          </div>
        </div>

      </div>
      <fileUpload v-if="upload" @cancel="upload = false"/>

      <div class="add-comment" v-if="showCommentPopup">
          <div class="add-comment-popup">
            <h1>Dodaj komentarz</h1>
            <textarea v-model="comment"></textarea>
            <div class="add-comment-popup__footer">
                <button class="button-normal button-normal--cancel" @click="showCommentPopup = false; comment = ''">Anuluj</button>
                <button class="button-normal button-normal--media" @click="addPageComment()">Dodaj</button>
            </div>
          </div>
      </div>

      <div class="order-info" v-if="showOrderInfo">
        <div class="order-info__body">
          <span class="order-info-close" @click="showOrderInfo = false">
            <img src="../../assets/symbols/cancel.svg"/>
          </span>
          <p><span>Rodzaj zlecenia:</span> {{order.type.name}}</p>
          <p><span>Wydanie:</span> {{order.edition.name}}</p>
          <p><span>Format:</span> {{order.technicalSpecifications.width}}x{{order.technicalSpecifications.height}} mm</p>
          <p><span>Data obowiązywania oferty:</span></p>
          <p>{{order.offerFrom.split(' ').shift()}} - {{order.offerTo.split(' ').shift()}}</p>
          <p><span>Termin przekazania plików do druku:</span></p>
          <p>{{order.orderForPrinting.split(' ').shift()}}, godz. {{order.orderForPrinting.split(' ').pop()}}</p>
          <p><span>Koordynator MediaMarkt:</span> {{order.mediaMarktCoordinator.name}} {{order.mediaMarktCoordinator.surname}}</p>
          <p><span>Koordynator Gutenberg:</span> {{order.gutenbergCoordinator.name}} {{order.gutenbergCoordinator.surname}}</p>
          <p></p>
        </div>
      </div>

      <popup 
        v-if="userAlert"
        text="Jesteś w trybie podglądu. Nie możesz edytować zlecenia." 
        cancelButton="Ok"
        @canceled="userAlert = !userAlert; userAlertAccepted = true; orderBlocked = true"/>

  </div>
</template>

<script>

import labelInfo from '@/components/blocks/labelInfo.vue'
import Products from '@/components/Product/Products.vue'
import orderPages from '@/components/blocks/orderPages.vue'
import orderSearch from '@/components/blocks/orderSearch.vue'
import productsInOrder from '@/components/blocks/productsInOrder.vue'
import fileUpload from '@/components/blocks/fileUpload.vue'
import editOrderUpload from '@/components/blocks/editOrderUpload.vue'
import switchPage from '@/components/blocks/switchPage.vue'
import popup from '@/components/blocks/popup'
import globalSearch from '@/components/blocks/globalSearch.vue'
import headlines from '@/components/blocks/orderEdit/headlines.vue'
import legals from '@/components/blocks/orderEdit/legals.vue'
import _ from 'lodash';
import { setTimeout } from 'timers';


export default {
  name: 'OrderEdit',
  props: ['id'],
  components:{

    labelInfo,
    Products,
    orderPages,
    productsInOrder,
    orderSearch,
    fileUpload,
    switchPage,
    editOrderUpload,
    popup,
    globalSearch,
    headlines,
    legals,

  },
  data () {
    return {

      pageTitle: 'Edycja zlecenia',

      order: '',
      tableType: 'order',
      pageId: 0,
      upload: false,
      showOrderInfo: false,
      pageBlockedBy: '',
      blockedByMe: false,
      orderBlocked: false,
      blockInterval: null,
      checkInterval: null,
      selectedPages: [],
      draggedProduct: null,

      // Alert dla user'a w przypadku edycji
      userAlert: false,
      userAlertAccepted: false,

      addSingle: '',
      comment: '',
      showCommentPopup: false,
      blockAddPage: false,

      hideSearch: false,
      statuses: false,
      statusList: [],
      filesList:[],

      historyStatusList: [],
      historyId: '',
      historyMode: false,
      histories: [],
      orderToCompare: null,
      originalOrderId: 0,
      currentHistoryStatus: '',

      copyTest: false,

    }
  },
  watch:{

    order(){

      if(!this.checkGutUser()){
      
        this.isOrderBlocked();

      }

      this.checkEditor();

      if(!this.historyMode){

        if(this.historyStatusList.length == 0 ){
          this.getHistoryList();
        }
        this.statusCode();

        let dataFromProduct = localStorage.getItem('selectOrderPage');

        if ( dataFromProduct ) {

          this.$refs.orderPages.activePage  = parseInt(dataFromProduct);

          this.tableType = 'page';
          this.pageId = parseInt(dataFromProduct);

        }

        let backToTheFuture = this.getDataFromStorage('backFromHistoryProduct');

        if ( backToTheFuture ) {

          this.historyId = backToTheFuture.historyId;
          
          this.getHistoryOrder();

          if(backToTheFuture.pageId){

            setTimeout(() => {
              this.tableType = 'page';
              this.pageId = parseInt(backToTheFuture.pageId);                
            }, 1500);

          }

          this.clearStorage('backFromHistoryProduct');
        }

      }

    },

  },
  methods:{

    isPageStatus(){

      if(this.order.isPageStatus){
        return true;
      }

      return false;

    },

    setHistory(option){
      if(!option) return;
      this.historyId = option.id; 
      this.currentHistoryStatus = option.name; 
      this.getHistoryOrder();
    },

    handleMultiPage(event){

      this.selectedPages = event;

    },

    showUserAlert() {

      if(!this.isPageStatus()){

        if(!this.getDataFromStorage('backFromPreviewProduct')){

          if ( !this.userAlertAccepted ) {
            this.userAlert = true;
          }

        }else{

          this.userAlertAccepted = true;
          this.orderBlocked = true;
          this.clearStorage('backFromPreviewProduct');

        }

      }

    },

    checkStatus(status){

      if(!this.historyMode && this.order && this.order.oldestPageStatus.code){
      
        const user = this.$parent.$refs.head.user.roles[0];
        const currentStatus = this.order.oldestPageStatus.code;

        if(status == 'waiting'){
          return true;
        }
        
        if(user == 'ROLE_ADMIN' || user == 'ROLE_SUPER_ADMIN'){
          return false;
        }

        if(user == 'ROLE_EDITOR'){
          return true;
        }

        if(user == 'ROLE_LOCAL' || user == 'ROLE_CENTRAL'){

          switch(status){

            case 'first_gun_build' :

              if(currentStatus == 'mm_build'){
                return false;
              }

              return true;

            break;

            case 'first_correct_gun' :

              if(currentStatus == 'first_correct_mm'){
                return false;
              }

              return true;
              
            break;

            case 'additional_correct_gun' :

              if(currentStatus == 'additional_correct_mm'){
                return false;
              }

              return true;
              
            break;

            case 'accept' :

              if(currentStatus == 'first_correct_mm' || currentStatus == 'second_correct_mm' || currentStatus == 'additional_correct_mm' || currentStatus == 'to_accept'){
                return false;
              }

              return true;
              
            break;

            case 'second_gun_build' :

              if(currentStatus == 'second_correct_mm'){
                return false;
              }

              return true;
              
            break;

            default :

              return true;

          }
          
        }

        if(user == 'ROLE_COORDINATOR'){

          switch(status){

            case 'first_correct_mm' :

              if(currentStatus == 'first_gun_build'){
                return false;
              }

              return true;

            break;

            case 'second_correct_mm' :

              if(currentStatus == 'first_correct_gun'){
                return false;
              }

              return true;
              
            break;

            case 'to_accept' :

              if(currentStatus == 'first_gun_build' || currentStatus == 'first_correct_gun' || currentStatus == 'second_gun_build' || currentStatus == 'additional_correct_gun'){
                return false;
              }

              return true;
              
            break;

            case 'additional_correct_mm' :

              if(currentStatus == 'to_accept'){
                return false;
              }

              return true;
              
            break;

            case 'archived' :

              if(currentStatus == 'accept' || currentStatus == 'cancelled'){
                return false;
              }

              return true;
              
            break;

            case 'cancelled' :

              return false;
              
            break;

            default :

              return true;

          }
          
        }

      }

    },

    statusCode(type){

      if(!this.order && !this.order.oldestPageStatus){
        return;
      }

      if(this.order){

        if(!this.historyMode){

          if(this.order.oldestPageStatus.code == 'accept'){

             this.orderBlocked = true;

          }
        
          return type != 'name' ? this.order.oldestPageStatus.code : this.order.oldestPageStatus.name;

        }

       return type != 'name' ? this.order.currentStatus.code : this.order.currentStatus.name;

      }
  
    },

    close(e){

      if(!e.target.classList.contains('badge')){

          this.statuses = false

      }

    },

    updateStatus(id, status){

      const token = localStorage.getItem('auth_token');

      this.$http.put(`orders/${this.order.id}/changes/${id}/status`, {}, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.getOrder();

          /*setTimeout(()=>{
            this.checkCentralUser();
          }, 1000)*/

        })
        .catch(error =>{
          
          console.error(error)

        })

    },

    activePageControl(id){

      if(this.pageId == id){

        this.pageId = 0;
        this.tableType = 'order'
        this.getFiles();

        return;

      }

      this.pageId = id;
      this.tableType = 'page';
      this.getFiles();

    },

    getOrder(){

      const token = localStorage.getItem('auth_token');

      this.$http.get(`orders/${this.id}`, {headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
        } }).then(response => {

          this.order = response.data;
          this.originalOrderId = parseInt(this.id);
          this.getFiles();
          this.blockAddPage = false;
          setTimeout(()=>{
            this.checkCentralUser();
          }, 200);

          let dataFromProduct = localStorage.getItem('selectOrderPage');
          
          if ( dataFromProduct ) {

            this.$refs.orderPages.activePage  = parseInt(dataFromProduct);

            setTimeout(() => {
              this.tableType = 'page';
              this.pageId = parseInt(dataFromProduct);                
            }, 1500);
            this.clearStorage('selectOrderPage');
          }

        })

    },

    getFiles(){

      if(this.tableType == 'order'){

        this.filesList = this.order.attachments ? this.order.attachments : [];
        return;

      }else if(this.tableType == 'page'){

        let obj = this.order.orderPages.find(o => o.id === this.pageId);
      
        if(obj){

          this.filesList = obj.attachments ? obj.attachments : [];

        }

        return;

      }

      this.filesList = [];

    },

    addPageComment(){

      const token = localStorage.getItem('auth_token');

      let comment = {
        content: this.comment
      }

      if(this.pageId != 0){

      this.$http.post(`order-page-comments/${this.pageId}`, comment, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.comment = '';
          this.showCommentPopup = false;
          this.$refs.orderPages.getPageComments();

        })
        .catch(error =>{
          
          this.comment = '';

        })

      }else{

        this.$http.post(`orders/${this.order.id}/comments`, comment, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.comment = '';
          this.showCommentPopup = false;
          this.$refs.orderPages.getOrderComments();

        })
        .catch(error =>{
          
          this.comment = '';

        })

      }

    },

    getFormData(){

      const token = localStorage.getItem('auth_token');

      this.$http.get('order/form/data', {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.statusList = response.data.status;

        })
        .catch(error =>{

            console.error(error.response);

        })

    },

    getHistoryList(){

      const token = localStorage.getItem('auth_token');

      this.$http.get(`order-histories/${this.order.id}/histories`, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.historyStatusList = [];

          response.data.list.forEach(element => {
            this.historyStatusList.push({id: element.id, name: element.oldStatus.name})
          });

          this.histories = response.data.list;

        })
        .catch(error =>{

          console.error(error.response);

        })

    },

    getHistoryOrder(){
      

      let historyId;
      
      if(this.historyId != ''){

        historyId = this.historyId;

      }

      const token = localStorage.getItem('auth_token');

      this.$http.get(`order-histories/${historyId}`, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          if(this.historyId != ''){
          
            this.historyMode = true;
            this.orderBlocked = true;
            let historyName = this.historyStatusList.find(history => history.id == this.historyId);
            this.currentHistoryStatus = historyName.name;

          }

          this.order = '',
          this.order = response.data;
          this.getFiles();
          this.blockAddPage = true;
          const findIndex = this.histories.findIndex(history => history.id === this.historyId);
          const toCompare = this.histories[findIndex + 1].id
          this.getHistoryOrderToCompare(toCompare ? toCompare : '')

        })
        .catch(error =>{

          console.error(error.response);

        })

    },

    getHistoryOrderToCompare(id){

      if(!id) return;

      this.orderToCompare = {};

      const token = localStorage.getItem('auth_token');

        this.$http.get(`order-histories/${id}`, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.orderToCompare = response.data;
          //this.$refs.productsInOrder.manager();

        })
        .catch(error =>{

          console.error(error);

        })

    },

    turnOffHistory(){

      let button = document.querySelector('.vs__clear');
      button ? button.click() : '';

      if(this.historyMode){
        this.getOrder();
        this.$refs.productsInOrder.manager();
      }
      
      this.historyMode = false;
      this.historyId ='';
      this.orderBlocked = false;
      this.currentHistoryStatus = '';

    },

    checkCentralUser(selectedPageId){

      const user = this.$parent.$refs.head.user;
      const author = this.order.author;
      const coordinatorMM = this.order.mediaMarktCoordinator;

        if(user.roles[0] == 'ROLE_LOCAL' || user.roles[0] == 'ROLE_CENTRAL'){

          if(!this.historyMode){

            let code = '';

            if(this.order.isPageStatus){

              if(this.pageId !== 0){

                const page = this.order.orderPages.find(o => o.id == this.pageId)

                if(page) code = page.status.code;

              }

              if(selectedPageId){

                const page = this.order.orderPages.find(o => o.id == selectedPageId)

                if(page) code = page.status.code;

              }

            }else{

              code = this.order.oldestPageStatus.code;

            }
          
            if(code == 'to_accept' || code == 'first_gun_build' || code == 'second_gun_build' || code == 'first_correct_gun' || code == 'additional_correct_gun' || code == 'accept' || code == 'archived' || code == 'cancelled'){
              
              this.orderBlocked = true;
              this.showUserAlert();
              return true;

            }
            
            if(user.id != coordinatorMM.id){
              
              this.orderBlocked = true;
              this.showUserAlert();
              return true;

            }

            this.orderBlocked = false;
            return false;

          }else{

            return true;

          }

        }

    },

    checkEditor(){

      const user = this.$parent.$refs.head.user;

        if(user.roles[0] == 'ROLE_EDITOR'){

          if(!this.historyMode){
          
            let code = '';

            if(this.isPageStatus()){

              if(this.pageId !== 0){

                const page = this.order.orderPages.find(o => o.id == this.pageId)

                if(page) code = page.status.code;

              }

            }else{

              code = this.order.oldestPageStatus.code;

            }
          
            if(code == 'mm_build' || code == 'first_correct_mm' || code == 'second_correct_mm' || code == 'to_accept' || code == 'additional_correct_mm' || code == 'archived' || code == 'cancelled'){

              this.orderBlocked = true;
              this.showUserAlert();
              return true;

            }

          }else{

            return true;

          }

        }

    },

    checkGutUser(){

    const user = this.$parent.$refs.head.user;

      if(user.roles[0] == 'ROLE_ADMIN' || user.roles[0] == 'ROLE_SUPER_ADMIN' || user.roles[0] == 'ROLE_COORDINATOR' || user.roles[0] == 'ROLE_EDITOR'){

        return true;

      }

      return false;

    },

    blockOrder(){

     if(!this.checkCentralUser() && !this.checkGutUser()){
     
      this.blockedByMe = true;

        const token = localStorage.getItem('auth_token');

        this.$http.post(`orders/${this.id}/blocks`, {}, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }).then(response => {
          console.log('blokuje')
        });

     }

    },

    isOrderBlocked(){

      clearInterval(this.checkInterval);

      if(!this.historyMode){

        this.orderBlocked = true;

        const user = `${this.$parent.$refs.head.user.name} ${this.$parent.$refs.head.user.surname}` ;

        const token = localStorage.getItem('auth_token');

        this.$http.get(`orders/${this.id}/check/block`, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              const checkUser = response.data.blockByUser == user;

              if(response.data.isBlocked && !checkUser){

                this.orderBlocked = true;
                this.blockedByMe = false;

                if(this.pageBlockedBy == ''){
                  this.pageBlockedBy = response.data.blockByUser;
                }
                
                this.checkInterval = setInterval(()=>{
                  this.isOrderBlocked();
                }, 10000*6)

                return;

              }

              clearInterval(this.checkInterval);
              this.pageBlockedBy = '';
              this.orderBlocked = false;

              if(!this.blockInterval){
              
                this.blockOrder();

              }
              
              this.blockInterval = setInterval(()=>{
                this.blockOrder();
              }, 10000*6)

              return;

            })
            .catch(error =>{

              console.error(error.response);

            })

            return;

      }

      clearInterval(this.checkInterval);

    },

    unblockOrder(){

      clearInterval(this.blockInterval);
      clearInterval(this.checkInterval);

      if(this.blockedByMe){
      
        const token = localStorage.getItem('auth_token');

          this.$http.post(`orders/${this.id}/unblocks`, {}, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {
            console.log('zamówienie odblokowane')
          });

      }

    },

  },
  mounted(){

    this.$root.$emit('menu');
    this.getOrder();
    this.getFormData();

  },
  computed: {

    orderedHistory: function () {

      return _.orderBy(this.historyStatusList, 'id', 'asc')

    }

  },
  beforeDestroy() {
    this.unblockOrder();
  },
  beforeRouteLeave (to, from, next) {

    this.unblockOrder();
    next();

  }
};
</script>

<style lang="scss" scoped>

.header-edit-order{
  width:100%;
  margin-bottom: 15px;
  display:flex;
  align-items: center;
  justify-content: space-between;

  & h1{
    position: relative;
    cursor:default;

    &:hover > .order-tooltip{
      visibility: visible;
      cursor: pointer;
    }
  }
  
}

.order-name{
  display:flex;
  align-items: center;
  width:50%;

  p{
    padding: 0;
    margin:0 5px 0px 20px;
  }
}

.order-settings{
  display:flex;
  width:35%;
  justify-content: space-between;
  align-items: flex-end;

  & .editor{

    & p{
      margin:0;
      text-transform: capitalize;
    }

    & span{
        color:#d3020c
    }
  }

}

.history{
  display:flex;
  flex-wrap: wrap;
  width:60%;
  border-radius: 5px;
  background: #DADADA;
  margin-bottom: 5px;

  & .history-cancel{
    display:flex;
    flex-direction: row-reverse;
    width:100%;
    padding:5px;
    padding-bottom: 0px;

    & img{
      display:block;
      width:15px;
    }
  }

  & .history-cell{
    padding: 0px 5px;
    display:flex;
    align-items: center;
    
    & p{
      color: #E3000B;
      font-size:13px;
      font-weight: 400;
      margin: 0;
      cursor: pointer;
    }

    & .v-select{
      width:100% !important;
    }
  }
}

.badge--header{
  width:auto;
  padding: 10px;
  margin-left: 1%;
  margin-bottom: 5px;
  position: relative;
  cursor:pointer;

  &:hover .order-tooltip{
    visibility: visible;
  }
}

.edit-body{
  display: flex;
  grid-template-columns: 12% 67% 1% 20%;
  flex-wrap: wrap;
  width: 100%;
  min-height: 80vh;
  margin-bottom:0px;

  &.hideSearch &__column{

    &:nth-child(2){
      width: 86%
    }

    &:nth-child(4){
      width: 1%;
      position: absolute;
      right: -100%;
    }

    &:nth-child(6){
      width: 87%;
    }
  }

  &__column{
    display:flex;
    flex-direction: column;
    position:relative;
    padding:0px 10px;

    &:nth-child(1){
      padding-left: 0px;
      width:12%
    }
    
    &:nth-child(2){
      border: 1px #d3020c solid;
      width: 67%
    }

    &:nth-child(3){
      align-items: center;
      justify-content: center;
      width: 1%
    }

    &:nth-child(4){
      justify-content: space-between;
      padding-right: 8px;
      width: 19%;

      &.hideSearch{
        visibility:hidden;
      }
    }

    &:nth-child(5){
      width: 12%
    }

    &:nth-child(6){
      width: 67%;
      justify-content: space-between;
    }

    & > .view-body > .view-data > .view-data__header{
      padding-top:0 !important;
    }
  }

}

.button-group--module{
  justify-content: space-between;

  & button{
    width:45%;
    height:50px;
  }
}

.add-comment{
  position:fixed;
  display:flex;
  align-items: center;
  justify-content: center;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background: rgba(172, 172, 172, 0.411);
}

.add-comment-popup{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:30%;
    padding:20px;
    z-index: 100;
    background:#fff;
    border:1px solid red;

    & h1 {
      margin: 10px 0px;
    }

    & textarea{
      width:80%;
      height:100px;
      margin:5% 0%;
    }

    &__footer{
      display:flex;
      justify-content: space-between;
      align-items: center;
      width:80%;
    }
}

.hide-icon{
  font-size: 24px;
  cursor:pointer;

  &.hideSearch{
    transform: rotate(180deg)
  }
}

.statuses{
  position:absolute;
  margin-top:20px;
  width:auto;
  background:#fff;
  z-index: 100;
  left:0;
  visibility: hidden;

  & ul{
    margin:0;
    padding: 0;
    list-style: none;
    text-align: left;

    & li{
      padding:10px 5px;

      &:nth-child(odd){
        background:#edf7ff
      }
    }
  }

  &.show{
    visibility: visible;
  }
}

.list-icon{
    display: block;
    width: 15px;
    opacity: 0.6;
}

.order-tooltip{
  position:absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height:24px;
  padding: 0px 5px;
  font-size: 10px;
  top:0px;
  margin-top:-23px;
  right:-35px;
  text-transform: initial;
  background:#E3E4E4;
  color:#7F8FA4;
  visibility: hidden;
  z-index: 100;
}

.order-info{
  position:absolute;
  left:30%;
  top:9%;
  background:#fff;
  border: 1px #d3020c solid;
  min-width: 380px;

  &__body{
    padding:30px;
    position:relative;

    & span{
      font-weight: 700;
    }

    & .order-info-close{
      position:absolute;
      top:20px;
      right:20px;
      cursor:pointer;
    }
  }
}

.disabled-status{
  cursor:default;
  opacity: 0.5;
}

.history-select .vs__actions{
  min-width: auto !important;
}

.order-alert {
  width: 100%;
  min-height: 30px;
  line-height: 30px;
  background-color: #d3020c;
  color: #ffffff;
  text-align: center;
}

</style>
